"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _MyNetworkError = _interopRequireDefault(require("./errors/MyNetworkError"));
var _GlobalErrorHandler = _interopRequireDefault(require("./GlobalErrorHandler"));
var TimeoutWatcher = /*#__PURE__*/function () {
  function TimeoutWatcher() {
    (0, _classCallCheck2.default)(this, TimeoutWatcher);
    (0, _defineProperty2.default)(this, "timeoutInterval", void 0);
    (0, _defineProperty2.default)(this, "interval", void 0);
  }
  return (0, _createClass2.default)(TimeoutWatcher, [{
    key: "setTimeoutInterval",
    value: function setTimeoutInterval() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 150;
      this.timeoutInterval = time;
    }
  }, {
    key: "startCounting",
    value: function startCounting() {
      var _this = this;
      this.setTimeoutInterval();
      this.interval = setInterval(function () {
        if (_this.timeoutInterval <= 0) {
          clearInterval(_this.interval);
          var error = new _MyNetworkError.default();
          _GlobalErrorHandler.default.handleException(error);
        }
        _this.timeoutInterval -= 1;
      }, 1000);
    }
  }, {
    key: "responseReceived",
    value: function responseReceived() {
      this.setTimeoutInterval();
      clearInterval(this.interval);
    }
  }]);
}();
var _default = exports.default = TimeoutWatcher;